import { render, staticRenderFns } from "./BulkPreviewAddCommentaryDialog.vue?vue&type=template&id=3b6eaee9&scoped=true"
import script from "./BulkPreviewAddCommentaryDialog.vue?vue&type=script&lang=js"
export * from "./BulkPreviewAddCommentaryDialog.vue?vue&type=script&lang=js"
import style0 from "./BulkPreviewAddCommentaryDialog.vue?vue&type=style&index=0&id=3b6eaee9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b6eaee9",
  null
  
)

export default component.exports